// removed by extract-text-webpack-plugin
module.exports = {"root":"src-components-Common-Loading-index-root-19ld7","spin":"src-components-Common-Loading-index-spin-1CdzH"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Common/Loading/index.css
 ** module id = 262
 ** module chunks = 0
 **/